import {
  EmailReportAssetCreateRequest,
  EmailReportAssetInputs,
  EmailReportAssetUpdateRequest,
} from '../../../types/app/emailReportAsset.types';

export const convertDataFromInputToCreateRequest = (
  data: EmailReportAssetInputs,
): EmailReportAssetCreateRequest => ({
  id: data.id,
  assetId: data.assetId,
  emailReportId: data.emailReportId,
});

export const convertDataFromInputToUpdateRequest = (
  data: EmailReportAssetInputs,
): EmailReportAssetUpdateRequest => ({
  id: data.id,
  assetId: data.assetId,
  emailReportId: data.emailReportId,
});
